import {mapActions, mapGetters, mapMutations} from "vuex";
import AOS from 'aos';
import 'aos/dist/aos.css';
//sections
import productCard from '@/components/product-card/index.vue';

export default {
  name: "home",
  components: {
    productCard,
  },
  data() {
    return {
      currentCollection: [],
      currentMeta: null,
    }
  },
  head: {
    title: function () {
      return this.currentMeta ? {
        inner: this.currentMeta.title,
        separator: '|',
        complement: 'KATY CORSO',
      } : {
        inner: 'KATY CORSO',
      }
    },
    meta: function () {
      let meta = []
      if (this.currentMeta) {
        let {metaDescription, metaKeywords, metaTitle } = this.currentMeta;

        if (metaDescription) meta.push({n: 'description', c: metaDescription, id: 'description'})
        if (metaKeywords) meta.push({n: 'keywords', c: metaKeywords, id: 'keywords'})
        if (metaTitle) meta.push({n: 'og:title', c: metaTitle, id: 'og:title'})
        if (metaDescription) meta.push({n: 'og:description', c: metaDescription, id: 'og:description'})
      }
      return meta
    }
  },
  watch: {
    '$route'(newVal) {
      if (newVal) {
        this.fetchList(this.$route.params.slug).then(() => {
          this._setCurrentCollection();
        })
      }
    }
  },
  created() {
    this.fetchList(this.$route.params.slug).then(() => {
      this._setCurrentCollection();

      if(this.top !== null){
        setTimeout(()=>{
          window.scrollTo({
            top: this.top,
            behavior: "smooth"
          });
        },300)
      }
    })

  },
  computed: {
    ...mapGetters({
      list: 'catalog/list',
      favoriteList: 'basket/favorites',
      isAuth: 'auth/isAuthenticated',
      top: 'catalog/top',
    }),
    formattedList() {
        if (!this.list) return []
        if (!this.favoriteList) return []
        return this.list.collections.data.map(e => {
          e.dresses.data.map(j => {
            const item = this.favoriteList.find(t => t.slug === j.slug)
            j.selected = !!item
          })
          return e
        })
    },
  },
  mounted() {
    AOS.init({
      disable: function () {
        const maxWidth = 700;
        return window.innerWidth <= maxWidth;
      }
    });
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      fetchList: 'catalog/GET_PRODUCTS'
    }),
    _setCurrentCollection() {
      this.currentCollection = []
      this.currentMeta = null;
      let currentData = null
      if (this.$route.query.collection) {
        for (let j in this.formattedList) {
          for (let i in this.formattedList[j].dresses.data) {
            if (this.formattedList[j].dresses.data[i].collectionSlug === this.$route.query.collection) {
              currentData = this.formattedList[j];
            }
          }
        }
      } else {
        currentData = this.formattedList[0];
      }

      if (currentData) {
        let {dresses, metaDescription, metaKeywords, metaTitle , title} = currentData;
        this.currentCollection = dresses.data;
        this.currentMeta = {metaDescription, metaKeywords, metaTitle , title};
      }
      this.$emit('updateHead');
    },
    scrollDown(slug){
      this.$router.replace({name: this.$route.name, params: {slug: this.$route.params.slug}, query: {collection: `${slug}`}}).catch(()=>{console.log()})
      window.scrollTo({
        top: 550,
        behavior: "smooth"
      });
    },
    changeCollection(slug) {
      this.$router.push({
        name: this.$route.name,
        params: {slug: this.$route.params.slug},
        query: {collection: slug}
      }).catch(()=>{})
    }
  }
}
